import * as React from 'react'
import { useTranslation } from 'react-i18next'

export type DataCompletenessListItemProps = {
    instancesWithData: number
    totalInstances: number
    completenessPercentage: number
    gridTemplateColumns?: string
}

export const DataCompletenessListItem: React.FC<
    DataCompletenessListItemProps
> = ({
    instancesWithData,
    totalInstances,
    completenessPercentage,
    gridTemplateColumns,
}) => {
    const { t } = useTranslation('translations')

    return (
        <li
            data-testid="summary-dropdown-content-list-data-completeness"
            className="contents font-inter"
            style={{
                display: 'contents',
                gridTemplateColumns: gridTemplateColumns,
            }}
        >
            <div className="col-span-full border-t border-neutral-200" />
            <span className="col-start-1 min-w-0 truncate whitespace-nowrap text-left text-xs font-medium leading-4">
                {t('analytics.usage_and_cost.summary.data_completeness')}
            </span>
            <span
                className="col-start-2 justify-self-end text-xs font-semibold leading-[18px]"
                data-testid="summary-dropdown-content-list-data-completeness-value"
            >
                {instancesWithData} / {totalInstances}
            </span>
            <span
                className="text-label-xsmall inline-flex min-w-6 items-center justify-center gap-0.5 justify-self-end rounded-[6px] border border-neutral-300 px-1 py-[2px] text-regular"
                data-testid="summary-dropdown-content-list-data-completeness-badge"
            >
                {completenessPercentage}%
            </span>
        </li>
    )
}
